export default "__VITE_ASSET__sbRGVMdm__"